import Loader from "react-loader-spinner";
import momentJalaali from "moment-jalali";
import DatePicker from "react-datepicker2";
import { Alert, Button, Col, Form, Modal, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCashRegister, faCreditCard, faMoneyCheck, faTimes } from "@fortawesome/free-solid-svg-icons";
import { addSpecialDocument } from "../store/api/DocumentsAPI";
import { useEffect, useRef, useState } from "react";
import NewNumberInput from "../../Components/NewNumberInput";
import { CheckLg, DashCircle, ExclamationTriangle, List } from "react-bootstrap-icons";
import ModalSelectCustomer from "../../Components/Modals/ModalSelectCustomer";
import ModalAccountLevel3 from "../../Components/Modals/ModalAccountLevel3";
import ModalSelectCostCenter from "./ModalSelectCostCenter";
import { getSettingValue, keyIsLetterOrNumber, setErrorDialog } from "../../store/api/CommonFunctions";
import { getRemainedAccount } from "../../store/api/CommonFunctions";
import { useDispatch } from "react-redux";
import { getSystemSettingsByCallback } from "../../store/api/SystemSettingsAPI";
const ModalSpecialDocuments = (props) => {
    const frm = useRef();
    const dispatch = useDispatch();
    const [remainedAcc, setRemainedAcc] = useState({});
    const [submitError, setSubmitError] = useState(null);
    const docDate = useRef(momentJalaali().local("en").format("YYYY-MM-DD HH:mm"));
    const [selectedCostCenter, selectCostCenter] = useState(null);
    const [popCustomer, setPopCustomer] = useState({ show: false });
    const [popAccLevel3, setPopAccLevel3] = useState({ show: false });
    const [popCostCenter, setPopCostCenter] = useState({ show: false });
    const [settings, setSettings] = useState([]);
    const [sourceAcc, setSourceAcc] = useState(null);
    const [destAcc, setDestAcc] = useState(null);
    const [pending, setPending] = useState(false);
    const { handleSubmit, register, errors } = useForm();
    const { popData, setPopData } = props;
    const [paySettelment, setPaySettlement] = useState(false);
    const { show, type, docAttachmentType, docAttachmentID, cardIDs, accountID, accountCat, accountName } = popData;
    let [sourceTitle, setSourceTitle] = useState("");
    let [destTitle, setDestTitle] = useState("");
    let title = "";

    let icon = faCreditCard;
    switch (type?.toLowerCase()) {
        case "accountwithdrawal":
            icon = faMoneyCheck;
            title = "برداشت از حساب";
            sourceTitle = "حساب بانکی";
            destTitle = "طرف حساب";
            break;
        case "accountdeposit":
            icon = faMoneyCheck;
            title = "واریز به حساب";
            sourceTitle = "واریز کننده";
            destTitle = "حساب بانکی ";
            break;
        case "posdeposit":
            title = "حساب کارتخوان"
            sourceTitle = "واریز کننده";
            destTitle = "حساب کارتخوان";
            break;
        case "cashreceive":
            icon = faCashRegister;
            title = "دریافت نقد ";
            sourceTitle = "پرداخت کننده";
            destTitle = "حساب صندوق";
            break;
        case "cashpay":
            icon = faCashRegister;
            title = "پرداخت نقد ";
            sourceTitle = "حساب صندوق";
            destTitle = "طرف حساب";
            break;
        case "transferaccount":
            icon = faMoneyCheck;
            title = "انتقال بین حسابها ";
            sourceTitle = "حساب مبدا";
            destTitle = "حساب مقصد";
            break;
        case "durationalsettlement":
            icon = faCashRegister;
            title = "تسویه حساب دوره ای";
            if (!paySettelment) {
                sourceTitle = "طرف حساب";
                destTitle = "واریز به حساب";
            }
            break;
        case "guaranteecardsaleshare":
            icon = faCashRegister;
            title = "سهم از فروش کارت";
            sourceTitle = "حساب برند تولید کننده";
            destTitle = "حساب مقصد";
    }
    function close() {
        if (!pending) {
            setSourceAcc(null);
            selectCostCenter(null);
            setDestAcc(null);
            setPopData({ show: false });
            setRemainedAcc({});
            setPaySettlement(false);
        }
    }
    function onCheckPaySettlement(e) {
        if (e.target.checked) {
            setSourceTitle("برداشت از حساب");
            setDestTitle("طرف حساب");
        }
        setPaySettlement(e.target.checked);
        setSourceAcc(null);
        setDestAcc(null);
        setRemainedAcc({});
    }
    function showModalSourceAcc() {
        const lowerType = type.toLowerCase();
        if (lowerType === "accountdeposit" ||
            lowerType === "posdeposit" ||
            lowerType === "cashreceive" ||
            lowerType === "guaranteecardsaleshare" ||
            (lowerType === "durationalsettlement" && !paySettelment)) {
            const onSetData = (data) => {
                if (data) {
                    setSourceAcc({ AccountID: data.ID, AccountName: data.Name, AccountCat: data.Cat });
                    if (type !== "guaranteecardsaleshare") {
                        const onSet = (res) => {
                            if (res.RemainedAccount) {
                                res.AmountToPay = res.RemainedAccount;
                            }
                            setRemainedAcc(res);
                        }
                        getRemainedAccount(data.ID, data.Cat, onSet);
                    }
                }
            }           
            setPopCustomer({
                show: true,
                invoiceCustomers: true,
                setCustomerData: onSetData
            })
        }
        else if (lowerType === "accountwithdrawal") {
            setPopAccLevel3({ show: true, parentHardCode: "Banks", setAccData: setSourceAcc });
        }
        else if (lowerType === "transferaccount" || lowerType === "guaranteecardsaleshare" || (type.toLowerCase() === "durationalsettlement" && paySettelment)) {
            setPopAccLevel3({ show: true, setAccData: setSourceAcc });
        }
        else if (lowerType === "cashpay") {
            setPopAccLevel3({ show: true, parentHardCode: "CashTarget", setAccData: setSourceAcc });
        }
    }
    function showModalDestAcc() {
        const lowerType = type.toLowerCase();
        if (lowerType === "accountdeposit") {
            setPopAccLevel3({ show: true, parentHardCode: "Banks", setAccData: setDestAcc });
        }
        else if (lowerType === "accountwithdrawal" ||
            lowerType === "transferaccount" ||
            lowerType === "guaranteecardsaleshare" ||
            (lowerType === "durationalsettlement" && !paySettelment)) {
            setPopAccLevel3({ show: true, setAccData: setDestAcc });
        }
        else if (lowerType === "cashreceive") {
            setPopAccLevel3({ show: true, parentHardCode: "CashTarget", setAccData: setDestAcc });
        }
        else if (lowerType === "posdeposit") {
            setPopAccLevel3({ show: true, parentHardCode: "CashInTransit", hasHardCode: true, setAccData: setDestAcc });
        }
        else if (lowerType === "cashpay" || (lowerType === "durationalsettlement" && paySettelment)) {
            const onSetData = (data) => {
                if (data) {
                    setDestAcc({ AccountID: data.ID, AccountName: data.Name, AccountCat: data.Cat });
                    const onSet = (res) => {
                        if (res.RemainedAccount) {
                            res.AmountToPay = res.RemainedAccount;
                        }
                        setRemainedAcc(res);
                    }
                    getRemainedAccount(data.ID, data.Cat, onSet);
                }
            }

            setPopCustomer({
                show: true,
                invoiceCustomers: true,
                setCustomerData: onSetData
            })
        }
    }
    function submit(data) {
        if (Number(data.Amount) === 0) {
            setSubmitError("مبلغ باید بزرگتر از صفر باشد");
            return;
        }
        if (Number(data.SourceAccountID) === Number(data.DestAccountID) && Number(data.SourceAccountCat) === Number(data.DestAccountCat)) {
            setSubmitError("حساب مبدا و مقصد نمی تواند برابر باشد");
            return;
        }
        if (type?.toLowerCase() === "durationalsettlement") {
            data.DocumentDate = momentJalaali().format("YYYY-MM-DD HH:mm");
        }
        else {
            data.DocumentDate = docDate.current;
        }
        data.DocAttachmentType = docAttachmentType;
        data.DocAttachmentID = docAttachmentID;
        data.DocumentType = type;
        setPending(true);
        const onSuccess = (res) => {
            setPending(false);
            if (res.Data) {
                document.getElementById("comma_Amount")?.setAttribute("comma-value", "0");
                frm.current.reset();
                setSourceAcc(null);
                selectCostCenter(null);
                setDestAcc(null);
                setRemainedAcc({});
                setErrorDialog(dispatch, `سند حسابداری با شماره ${res.Data.DocumentNumber} صادر شد`);
            }
            else if (res.Error) {
                setSubmitError(res.Error);
            }

        }
        data.CardIDs = cardIDs;
        addSpecialDocument(data, onSuccess);
    }
    function showModalCostCenter(e) {
        if (e.key) {
            if (!keyIsLetterOrNumber(e.keyCode, e.key)) {
                return;
            }
            e.preventDefault();
        }
        const onSelect = (data) => {
            if (data) {
                selectCostCenter(data);
            }
        }
        setPopCostCenter({
            show: true,
            onSelect: onSelect
        });

    }
    function onChangeAmount(e) {
        setRemainedAcc({ ...remainedAcc, AmountToPay: e.target.value });
    }
    useEffect(() => {
        if (show) {
            if (Number(accountID) > 0) {
                const lowerType = type.toLowerCase();
                if (lowerType === "cashreceive") {
                    setSourceAcc({
                        AccountID: Number(accountID),
                        AccountCat: Number(accountCat),
                        AccountName: accountName
                    })
                }
                else if (lowerType === "cashpay") {
                    setDestAcc({
                        AccountID: Number(accountID),
                        AccountCat: Number(accountCat),
                        AccountName: accountName
                    })
                }
            }
        }
    }, [show])
    return (
        <Modal show={show} onHide={() => { }} size="lg">
            <ModalSelectCustomer popData={popCustomer} setCustomerPopup={setPopCustomer} />
            <ModalAccountLevel3 popData={popAccLevel3} setAccLevel3Popup={setPopAccLevel3} />
            <ModalSelectCostCenter popData={popCostCenter} setPopCostCenter={setPopCostCenter} />
            <Modal.Header className="headerStyle">
                <span>
                    <FontAwesomeIcon icon={icon} size="lg" /> &nbsp; {title}
                </span>
                <FontAwesomeIcon icon={faTimes} size="lg" onClick={close} />
            </Modal.Header>
            <Modal.Body className="bodyStyle">
                <form onSubmit={handleSubmit(submit)} ref={frm}>
                    {type?.toLowerCase() !== "durationalsettlement" &&
                        <Col md={3} xs={8} className="form-group mt-0">
                            <label>تاریخ سند</label>
                            <DatePicker isGregorian={false} timePicker={true} format="" className="form-control" value={momentJalaali(docDate.current)}
                                onChange={value => docDate.current = value.local("en").format("YYYY-MM-DD HH:mm")} inputJalaaliFormat="jYYYY/jMM/jDD HH:mm"
                            />
                        </Col>
                    }
                    <Row className="rowBorder mt-2" >
                        {type?.toLowerCase() === "durationalsettlement" &&
                            <div className="rowTitle">
                                <input type="checkbox" id="paySettlement" className="form-check-input" onChange={onCheckPaySettlement} />&nbsp;
                                <label htmlFor="paySettlement">پرداخت به طرف حساب</label>
                            </div>}
                        <Col md={4} className="form-group">
                            <label>{sourceTitle}:&nbsp;
                                {(type?.toLowerCase() === "cashreceive" || (type?.toLowerCase() === "durationalsettlement" && !paySettelment) || type?.toLowerCase() === "accountdeposit") && !isNaN(remainedAcc.RemainedAccount) && Number(remainedAcc.RemainedAccount) !== 0 && <span style={{ color: remainedAcc.Color }}>( {Math.abs(Number(remainedAcc.RemainedAccount)).toLocaleString(navigator.language, { minimumFractionDigits: 0 }) + remainedAcc.Type} )</span>}
                            </label>
                            <input type="hidden" name="SourceAccountID" readOnly value={sourceAcc?.AccountID ?? ""} ref={register({ required: true })} />
                            <input type="hidden" name="SourceAccountCat" readOnly value={sourceAcc?.AccountCat ?? ""} ref={register({ required: true })} />
                            <Form.Control readOnly value={sourceAcc?.AccountName ?? ""} />
                            {errors.SourceAccountID && <small className="errors">{sourceTitle} انتخاب نشده است</small>}
                            <Button className="btn-input-tiny" onClick={showModalSourceAcc} style={{ top: "26px" }}><List size={21} /></Button>
                        </Col>
                        <Col md={4} className="form-group">
                            <label>{destTitle}:&nbsp;
                                {(type?.toLowerCase() === "cashpay" || (type?.toLowerCase() === "durationalsettlement" && paySettelment)) && !isNaN(remainedAcc.RemainedAccount) && Number(remainedAcc.RemainedAccount) !== 0 && <span style={{ color: remainedAcc.Color }}>( {Math.abs(Number(remainedAcc.RemainedAccount)).toLocaleString(navigator.language, { minimumFractionDigits: 0 }) + remainedAcc.Type} )</span>}
                            </label>
                            <input type="hidden" name="DestAccountID" readOnly value={destAcc?.AccountID ?? ""} ref={register({ required: true })} />
                            <input type="hidden" name="DestAccountCat" readOnly value={destAcc?.AccountCat ?? ""} ref={register({ required: true })} />
                            <Form.Control readOnly value={destAcc?.AccountName ?? ""} />
                            {errors.DestAccountID && <small className="errors">{destTitle} انتخاب نشده است</small>}
                            <Button className="btn-input-tiny" onClick={showModalDestAcc} style={{ top: "26px" }}><List size={21} /></Button>
                        </Col>
                        <Col className="form-group">
                            <label>مرکز هزینه: </label>
                            <input type="hidden" ref={register({})} name="CostCenterID" readOnly value={selectedCostCenter?.ID ?? ""} />
                            <Form.Control type="text" readOnly
                                onKeyDown={showModalCostCenter} value={selectedCostCenter?.CenterName ?? ""} />
                            <Button className="btn-input-tiny" onClick={showModalCostCenter} style={{ top: "26px" }}><List size={21} /></Button>
                        </Col>
                        <Col md={4} className="form-group">
                            <label>مبلغ: </label>
                            <NewNumberInput inputname="Amount" reff={register({ required: true })} value={Math.abs(Math.round(remainedAcc?.AmountToPay ?? 0))} onChange={onChangeAmount} />
                            {errors?.Amount && <small className="errors">مبلغ را وارد کنید</small>}
                        </Col>
                        <Col md={8} className="form-group">
                            <label>توضیحات: </label>
                            <Form.Control name="DocumentDesc" ref={register({ required: true })}
                                defaultValue={title + (type?.toLowerCase() === "durationalsettlement" ? (" تا تاریخ " + momentJalaali().format("jYYYY/jMM/jDD")) : "")} />
                            {errors?.DocumentDesc && <small className="errors">توضیحات را وارد کنید</small>}
                        </Col>
                    </Row>
                    {submitError &&
                        <Alert variant="danger">
                            <ExclamationTriangle size={18} />&nbsp;
                            {submitError}
                            <FontAwesomeIcon icon={faTimes} size="lg" style={{ float: "left" }} onClick={() => setSubmitError(null)} />
                        </Alert>}
                    <Button className="group-Btn mt-2" variant="info" type="submit" disabled={pending ?? false}><CheckLg />&nbsp;ثبت سند&nbsp;</Button>
                    <Button className="group-Btn mt-2" variant="danger" onClick={close}><DashCircle size={16} />&nbsp; انصراف&nbsp;</Button>
                </form>
            </Modal.Body>
        </Modal>
    )

}
export default ModalSpecialDocuments;